import {
  LOAD_SUCCESS_TYPES_LOTS,
  LOAD_FAIL_TYPES_LOTS,
  SAVE_SUCCESS_TYPES_LOTS,
  SAVE_FAIL_TYPES_LOTS,
  UPDATE_SUCCESS_TYPES_LOTS,
  UPDATE_FAIL_TYPES_LOTS,
  DELETE_SUCCESS_TYPES_LOTS,
  DELETE_FAIL_TYPES_LOTS,
} from "../actions/typeLotAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_TYPES_LOTS:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_TYPES_LOTS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_TYPES_LOTS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_TYPES_LOTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_TYPES_LOTS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.type_lot_id === action.payload.type_lot_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_TYPES_LOTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_TYPES_LOTS:
      const filtered = state.data.filter((item) => {
        return item.type_lot_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_TYPES_LOTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
